import { apiHost } from './config'

let currentAuthToken = null

const api = (method, endpoint, data, options = {}) => {
  let headers = { 'Content-Type': 'application/json' }
  if (currentAuthToken) {
    headers['Authorization'] = currentAuthToken
  }

  return window
    .fetch(apiHost + '/' + endpoint, {
      method: method.toUpperCase(),
      headers: headers,
      body: JSON.stringify(data),
      ...options,
    })
    .then(response => {
      const { ok } = response

      if (ok) {
        return response.json().catch(() => {
          throw `Malformed JSON from ${endpoint}`
        })
      }

      return response
        .json()
        .catch(() => {
          throw `Malformed JSON from ${endpoint}`
        })
        .then(({ meta }) => {
          throw meta
        })
    })
}

export function setToken(token) {
  currentAuthToken = token
}

export default api
